import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class AssignPreparerService {

  constructor(private http: HttpClient) { }

  /**
   * Get country list
   */
  getCountries(
    baseUrl: string,
    params: any,
    globalService: any
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_code=fyl404`;

    // Build payload with AngularJS structure
    let requestParams = _.merge({}, globalService || {}, params);

    // Use application/x-www-form-urlencoded
    const urlEncoded = new URLSearchParams();
    Object.keys(requestParams).forEach(key => {
      if (requestParams[key] !== undefined && requestParams[key] !== null) {
        urlEncoded.set(key, requestParams[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  /**
   * Get US States list
   */
  getUSStates(
    baseUrl: string,
    params: any,
    globalService: any
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_code=oppj8b`;

    // Build payload with AngularJS structure
    let requestParams = _.merge({}, globalService || {}, params);

    // Use application/x-www-form-urlencoded
    const urlEncoded = new URLSearchParams();
    Object.keys(requestParams).forEach(key => {
      if (requestParams[key] !== undefined && requestParams[key] !== null) {
        urlEncoded.set(key, requestParams[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  /**
   * Get templates for preparer assignment
   */
  getTemplates(
    baseUrl: string,
    params: any,
    globalService: any
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_code=4pr8wo`;

    // Build payload with AngularJS structure
    let requestParams = _.merge({}, globalService || {}, params);

    // Use application/x-www-form-urlencoded
    const urlEncoded = new URLSearchParams();
    Object.keys(requestParams).forEach(key => {
      if (requestParams[key] !== undefined && requestParams[key] !== null) {
        urlEncoded.set(key, requestParams[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  /**
   * Save assigned preparer
   */
  saveAssignPreparer(
    baseUrl: string,
    formData: any[],
    jsonSettings: any,
    globalService: any,
    filterParams: any = {},
    leidList: any[] = []
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=d7mh38`;

    // Build payload EXACTLY like original AngularJS with proper fallbacks
    let params = _.merge({}, globalService || {}, filterParams);

    // Prepare JSON objects
    const jsonObj = JSON.stringify(formData);
    const jsonSettingsStr = JSON.stringify(jsonSettings);
    
    // Build checkLockedbj from leidList array (matches AngularJS format exactly)
    const checkLockedbj = leidList.map((leidItem: any) => {
      return {
        leid: leidItem.leid,
        consol_group_key: leidItem.group_obj_key,  // Note: group_obj_key maps to consol_group_key
        reporting_period: leidItem.reporting_period,
        combination_key: leidItem.combination_key,
        scenario_key: parseInt(filterParams?.scenario || globalService?.scenario || 0)
      };
    });

    // Essential parameters with fallbacks
    params.jsonObj = jsonObj;
    params.jsonSettings = jsonSettingsStr;
    params.tax_year = filterParams.tax_year || params.tax_year || jsonSettings.tax_year;
    params.scenario = filterParams.scenario || params.scenario || jsonSettings.scenario;
    params.jcd_key = filterParams.jcd_key || params.jcd_key || jsonSettings.jcd_key || 250;
    params.scenarioCode = filterParams.scenarioCode || filterParams.scenario_code || params.scenarioCode || "RAF";
    params.process_name = "Assign Template";
    params.checkLockedbj = JSON.stringify(checkLockedbj);
    params.is_issue_key_enabled = 'N';

    // Use application/x-www-form-urlencoded (NOT application/json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
